<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import Button from './components/Button.vue';
import Icon from './Icon.vue';

let {style, fullSize, title, closeBtn, theme} = defineProps(['style', 'fullSize', 'title', 'closeBtn', 'theme'])
const emit = defineEmits(['close'])
function onClose() {
  emit('close')
}

function clickAway(e) {
  if (e.target === e.currentTarget) {
    onClose()
  }
}

function onEscapeKey(event) {
  if (event.key === 'Escape') {
    onClose();
  }
}

onMounted(() => {
  document.addEventListener('keydown', onEscapeKey)
})

onBeforeUnmount(() => {
  document.removeEventListener('keydown', onEscapeKey)
})

</script>

<template>
  <Teleport to="body">
    <div :class="$style.background" :style="{
      alignItems: fullSize !== false? 'stretch' : 'center'
    }" @click="clickAway" :data-theme="theme">
      <div :class="[$style.modal, 'bg-base-100']" :style="{
        ...style,
        flex: fullSize !== false ? '1' : 'unset'
      }">

        <div class="flex items-center pl-3 pt-2 pr-2">
          <strong>{{ title }}</strong>
          <div class="flex-1"></div>
          <Button v-if="closeBtn !== false" @action="onClose" class="btn-ghost btn-circle btn-primary" title="close"><Icon size="10" name="fa--close" /></Button>
        </div>

        <div :class="$style.content">

          <slot></slot> 
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style module lang="less">
  .background {
    position: fixed;    
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;  
    background: #0008;
    display: flex;
    justify-content: center;
    z-index: 998;
    padding: 5px;

    @media (min-width: @screen-md) {
      & {
        padding: 20px;
      }
    }
    @media (min-width: @screen-lg) {
      & {
        padding: 50px;
      }
    }
  }
  .modal {
    // padding: 10px 20px;

    border-radius: 5px;
    z-index: 999;

    max-width: 700px;
    
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow: auto;
  }

  .content {
    flex: 1;
    display: flex;
    overflow: auto;

    flex-direction: column;
    gap: 10px;
    padding: 0 10px 10px 10px;

    @media (min-width: @screen-md) {
      & {
        padding: 0 20px 20px 20px;
      }
    }
  }
</style>
